var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankReceiptPattern(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 832,
    viewBox: "0 0 420 832",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20768_381212)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 832,
    fill: "url(#paint0_linear_20768_381212)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4377 -130.957C57.3395 -92.5464 29.8215 -62.9167 -14.8479 -53.58C-55.8684 -46.4953 -87.7295 -30.5229 -106.373 10.5581C-118.837 2.50292 -129.271 5.66057 -137.505 20.5243C-119.822 22.4085 -112.132 42.996 -114.662 69.2789C-114.57 72.5745 -114.112 74.6564 -110.556 76.2402C-98.0511 105.328 -77.1111 119.945 -50.6353 125.085C-56.087 135.271 -52.4203 149.54 -24.6191 178.664C-33.6245 209.413 -45.7402 237.388 -62.9704 260.747L-47.2455 265.505L-37.1866 247.925L-37.9403 267.702L-23.565 272.052C-23.6216 242.535 -18.651 213.127 -8.85147 183.634C23.8384 176.987 42.0607 167.001 42.2572 152.664C64.0313 163.536 88.9225 163.119 118.455 146.022C123.212 146.954 126.319 144.516 127.831 139.166C142.554 116.263 157.549 107.133 173.052 113.966C173.64 98.3341 167.269 89.0533 151.701 88.0081C163.125 25.1354 125.463 2.2132 100.399 -29.0412C80.5929 -54.5313 72.6588 -88.3525 77.4695 -130.991L77.4377 -130.957ZM64.8777 -89.4484C48.9553 -62.2276 21.378 -36.9879 -17.0438 -13.7269C-64.4336 23.5796 -60.2086 72.1985 7.9903 98.5536C79.7837 115.287 108.503 73.855 91.8337 19.7261C72.2093 -22.733 63.1258 -59.1763 64.8777 -89.4484Z",
    fill: "url(#paint1_linear_20768_381212)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.229 573.809C315.346 613.129 312.095 650.261 284.88 682.335C259.045 710.706 244.904 740.359 254.591 780.799C240.964 781.993 235.159 790.196 237.581 805.67C251.513 797.033 268.76 807.659 281.794 828.213C283.726 830.559 285.238 831.814 288.722 830.954C314.282 845.039 337.79 843.822 359.962 832.578C361.76 843.074 372.504 851.38 409.214 856.835C420.065 884.303 427.083 911.513 427.767 938.259L441.901 932.821L439.27 914.338L449.915 929.154L462.835 924.182C446.089 902.74 433.061 878.53 423.498 851.526C443.52 828.189 451.126 810.61 443.154 800.068C465.149 795.655 483.023 781.264 494.833 752.11C498.821 750.096 499.702 746.563 497.774 741.816C495.523 716.82 501.266 701.69 516.412 697.887C507.993 686.182 498.105 683.036 486.187 691.086C458.915 638.877 418.54 643.516 382.616 634.962C353.779 627.627 328.865 607.51 308.233 573.766L308.229 573.809ZM322.584 611.117C326.405 639.933 320.626 673.904 305.838 712.573C292.474 766.537 323.064 799.518 387.599 780.094C449.303 751.636 446.748 705.238 403.985 675.291C365.677 655.506 338.442 634.133 322.584 611.117Z",
    fill: "url(#paint2_linear_20768_381212)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20768_381212",
    x1: 0,
    y1: 0,
    x2: 355.203,
    y2: 855.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AD4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449707,
    stopColor: "#3EC1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A0AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20768_381212",
    x1: 112.438,
    y1: 199.587,
    x2: 46.5868,
    y2: -169.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20768_381212",
    x1: 520.771,
    y1: 794.487,
    x2: 263.713,
    y2: 562.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20768_381212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 832,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankReceiptPattern);
export default __webpack_public_path__ + "static/media/bank-receipt-pattern.4a4c50eb01ab6c875ea666471763dbd2.svg";
export { ForwardRef as ReactComponent };